import { type LockScope, scopeToColumns } from 'components/FieldLock/types'
import {
  API_LOAN_FIELD_LOCKS,
  API_LOAN_FIELD_LOCKS_ALL,
  API_LOAN_FIELD_LOCKS_BATCH,
  API_LOAN_FIELD_LOCKS_HISTORY,
} from 'config'
import Api from 'services/api'

export interface LockHistoryEntry {
  status: 0 | 1
  updatedBy: string
  updatedAt: string
}

export interface LockRow {
  id: number
  loanNumber: number
  scopeType: string
  borrowerSeperator: string
  fieldOrigin: string
  fieldKey: string
  status: 0 | 1
  updatedBy: string
  history: LockHistoryEntry[]
  createdAt: string
  updatedAt: string
}

export const getLoanFieldLocks = (loanNumber: number) => {
  return Api.get(API_LOAN_FIELD_LOCKS, { loanNumber })
}

export const getAllLoanFieldLocks = (loanNumber: number) => {
  return Api.get(API_LOAN_FIELD_LOCKS_ALL, { loanNumber })
}

export const getLoanFieldLockHistory = (loanNumber: number, scope: LockScope) => {
  return Api.get(API_LOAN_FIELD_LOCKS_HISTORY, { loanNumber, ...scopeToColumns(scope) })
}

export const setLoanFieldLock = (loanNumber: number, scope: LockScope, locked: boolean | null) => {
  return Api.put(API_LOAN_FIELD_LOCKS, { scope: scopeToColumns(scope), locked }, { loanNumber })
}

export const setLoanFieldLockBatch = (
  loanNumber: number,
  updates: Array<{ scope: LockScope; locked: boolean | null }>,
) => {
  return Api.post(
    API_LOAN_FIELD_LOCKS_BATCH,
    { updates: updates.map(({ scope, locked }) => ({ scope: scopeToColumns(scope), locked })) },
    { loanNumber },
  )
}
